// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"ce5b235d","204":"05bf5cfa","722":"31db4bb2","954":"7912a159"}[chunkId] + ".chunk.css";
};